import { useEffect, useRef } from 'react'
import './StartScreen.scss';
import store, { RootState } from "../store";
import { gameActions } from '../Game/gameSlice';
import { useAppSelector } from '../redux';
import ImageAsset from "../Components/ImageAsset";
import Button from '../Components/Button';
import { GamePlayState } from '../Enums/GameEnums';
import SpritesheetAsset from '../Components/SpritesheetAsset';

function Story() {

  const audioRef = useRef(null);
  const gameState = useAppSelector((state: RootState) => state.game);

  function getVoiceStep4() {
    const className = gameState.player.className
    const gender = gameState.player.gender
    return `BlackJack RPG_VO_${className}_${gender}_20.10.2023.mp3`
  }

  useEffect(() => {
    const audioSource = storyData[gameState.storyNumber].musicAsset();
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = audioSource;
      audioRef.current.play();
    } else {
      audioRef.current = new Audio(audioSource);
      audioRef.current.play();
    }
  }, [gameState.storyNumber])

  const storyData = {
    1: {
        text: "Oh no! The king’s crown has been stolen!",
        asset: 'story-1.gif',
        musicAsset: () => 'BlackJack RPG_VO_Line1_20.10.2023.mp3',
        next: () => {
            store.dispatch(gameActions.setStoryNumber(2));
        }
    },
    2: {
        text: "The castle’s CCTV surveillance system has caught a glimpse of the intruder.",
        asset: 'story-2.gif',
        musicAsset: () => 'BlackJack RPG_VO_Line2_20.10.2023.mp3',
        next: () => {
            store.dispatch(gameActions.setStoryNumber(3));
        }
    },
    3: {
        text: `"Halt! Who goes there?"`,
        asset: 'story-3.gif',
        musicAsset: () => 'BlackJack RPG_VO_Line3_20.10.2023.mp3',
        next: () => {
            store.dispatch(gameActions.setGamePlayState(GamePlayState.CHARACTER_SELECTION));
            store.dispatch(gameActions.setStoryNumber(4));
        }
    },
    4: {
        text: `"I must catch the thief and ensure that the king’s crown is safely returned!"`,
        asset: null,
        spritesheetAsset: gameState.player?.sprite,
        musicAsset: () => getVoiceStep4(),
        next: () => {
            store.dispatch(gameActions.setStoryNumber(5));
        }
    },
    5: {
        text: "It's dangerous to go alone! Take this.",
        asset: 'story-4.gif',
        musicAsset: () => 'BlackJack RPG_VO_Line5_20.10.2023.mp3',
        multiplier: 5,
        next: () => {
            store.dispatch(gameActions.setGamePlayState(GamePlayState.BETTING));
        }
  }
  };

  return (
    <div className="story-screen">
        <div className='story-screen_data'>
            <div className='story-screen_text'>{storyData[gameState.storyNumber].text}</div>
            {storyData[gameState.storyNumber].asset && <ImageAsset name={storyData[gameState.storyNumber].asset} multiplier={storyData[gameState.storyNumber].multiplier || null} />}
            {storyData[gameState.storyNumber].spritesheetAsset && <SpritesheetAsset name={storyData[gameState.storyNumber].spritesheetAsset} multiplier={storyData[gameState.storyNumber].multiplier || null} />}
        </div>

      <Button text="Next" onClick={storyData[gameState.storyNumber].next}></Button>
    </div>
  );
}

export default Story;
